"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.textStyles = exports.Text = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var styled_system_1 = require("styled-system");
// configure fallback fonts
var titleFontFamily = "\"MintGrotesk\", \"Trebuchet MS\", Helvetica, sans-serif";
var textFontFamily = "\"OldschoolGrotesk\", \"Trebuchet MS\", Helvetica, sans-serif";
var uiFontFamily = "\"Inter\", Helvetica, sans-serif";
var uiBaseStyles = {
    fontFamily: uiFontFamily,
    fontStyle: "normal",
    letterSpacing: "-0.008em",
    lineHeight: "150%",
    fontFeatureSettings: "'calt'", // enable contextual alternates for Inter (e.g. -> to →)
};
var paragraphBaseStyles = {
    fontFamily: textFontFamily,
    fontStyle: "normal",
    fontWeight: 400,
    letterSpacing: "0.008em",
    paragraphSpacing: "8px",
};
var textStyles = {
    // Title
    titleLarge: {
        fontFamily: titleFontFamily,
        fontSize: "48px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "120%",
        letterSpacing: "-0.01em",
    },
    titleMedium: {
        fontFamily: titleFontFamily,
        fontSize: "36px",
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "120%",
        letterSpacing: "-0.01em",
    },
    titleSmall: {
        fontFamily: titleFontFamily,
        fontSize: "32px",
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "120%",
        letterSpacing: "-0.005em",
    },
    headlineLarge: {
        fontFamily: textFontFamily,
        fontSize: "24px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "120%",
        letterSpacing: "-0.008em",
    },
    headlineMedium: {
        fontFamily: textFontFamily,
        fontSize: "20px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "120%",
        letterSpacing: "-0.008em",
    },
    headlineSmall: {
        fontFamily: textFontFamily,
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "120%",
        letterSpacing: "-0.005em",
    },
    // Paragraph
    paragraphLarge: __assign(__assign({}, paragraphBaseStyles), { fontSize: "16px", lineHeight: "150%" }),
    paragraphMedium: __assign(__assign({}, paragraphBaseStyles), { fontSize: "14px", lineHeight: "150%" }),
    paragraphSmall: __assign(__assign({}, paragraphBaseStyles), { fontSize: "12px", lineHeight: "150%" }),
    // UI
    uiLarge400: __assign(__assign({}, uiBaseStyles), { fontSize: "16px", fontWeight: 400 }),
    uiLarge500: __assign(__assign({}, uiBaseStyles), { fontSize: "16px", fontWeight: 500 }),
    uiLarge600: __assign(__assign({}, uiBaseStyles), { fontSize: "16px", fontWeight: 600 }),
    uiSmall400: __assign(__assign({}, uiBaseStyles), { fontSize: "14px", fontWeight: 400 }),
    uiSmall500: __assign(__assign({}, uiBaseStyles), { fontSize: "14px", fontWeight: 500 }),
    uiSmall600: __assign(__assign({}, uiBaseStyles), { fontSize: "14px", fontWeight: 600 }),
    uiTiny400: __assign(__assign({}, uiBaseStyles), { fontSize: "12px", fontWeight: 400 }),
    uiTiny500: __assign(__assign({}, uiBaseStyles), { fontSize: "12px", fontWeight: 500 }),
    uiTiny600: __assign(__assign({}, uiBaseStyles), { fontSize: "12px", fontWeight: 600 }),
    uiCaption: __assign(__assign({}, uiBaseStyles), { fontSize: "10px", textTransform: "uppercase", fontWeight: 500, letterSpacing: "0.05em" }),
    // DEPRECATED
    bodyMedium: {
        fontFamily: textFontFamily,
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px",
        letterSpacing: "normal",
    },
    bodySmall: {
        fontFamily: textFontFamily,
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "20px",
        letterSpacing: "normal",
    },
    bodyCaption: {
        fontFamily: textFontFamily,
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "20px",
        letterSpacing: "normal",
    },
};
exports.textStyles = textStyles;
/**
 * Text UI component
 * @param {string=} variant - Must be one of the predefined TextVariants
 * @param {string=} as - By default, a div is used to display the text. Use this prop to specify something else like span or p.
 */
var Text = (0, styled_1.default)("div")(styled_system_1.color, styled_system_1.layout, styled_system_1.space, styled_system_1.typography, (0, styled_system_1.system)({
    textTransform: {
        property: "textTransform",
    },
}), (0, styled_system_1.variant)({ variants: textStyles }));
exports.Text = Text;
